(function () {
  function initTermsCheckbox() {
    const checkbox = document.querySelector('#CustomTermsCheckbox');
    const checkoutBtn = document.querySelector('#CartCheckoutButton');

    if (!checkbox || !checkoutBtn) return;

    const syncState = () => {
      checkoutBtn.disabled = !checkbox.checked;
    };

    checkbox.addEventListener('change', syncState);
    syncState();
  }

  document.addEventListener('DOMContentLoaded', initTermsCheckbox);

  document.addEventListener('click', function () {
    setTimeout(initTermsCheckbox, 100);
  });
})();